import { getAxiosInstance, getDomain } from '@modv/sdk'

export async function getUserPermission(organisationId, userId) {
  const { data } = await getAxiosInstance().get(`${getDomain()}/admin/organisation/${organisationId}/user/${userId}/permission`)
  return data
}

export async function copyUserPermissions(organisationId, data) {
  await getAxiosInstance().put(`${getDomain()}/admin/organisation/${organisationId}/user/permission/copy`, data)
}
